import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe";
import { SingleDayTextInput } from "./SingleDayTextInput";
import { myThryveXMLHTTPRequests } from "@/services/ThryveRequests";


interface StringKeyArray {
    [index: string]: number;
}


export class SmartWearableData{
    protected attributePrefix = "Smart Wearables";
    protected attributePrefixDe = "Smart Wearables";
    static ToHandle = { 
        "Steps":"Schritte",
        "CoveredDistance":"Distanz",
        "FloorsClimbed":"Etagen",
        "BurnedCalories":"Gesamtkalorien",
        "ActiveBurnedCalories":"Verbrannte Kalorien",
        "ActivityDuration":"Gesamtdauer der Aktivitäten",
        "ActiveDuration":"Aktive Minuten",
        "SleepDuration":"Gesamtschlafzeit",
        "SleepInBedDuration":"Zeit im Bett",
        "SleepREMDuration":"REM-Schlaf",
        "SleepDeepDuration":"Tiefschlaf",
        "SleepStartTime":"Schlafenszeit Anfang",
        "SleepEndTime":"Schlafenszeit Ende",
        "SleepEfficiency":"Schlaf-Effizienz",
        "HeartRate":"Durchschnittliche Herzfrequenz",
        "HeartRateResting":"Ruhepuls",
    }

    constructor(){
        //this.ToSingleDayTextInput = new SingleDayTextInput('SmartWearableData');
    }

    public getDeName(engname: String){
        //console.log(engname)
        let myAttributeNames = DataSafe.myAttributes();
        let myAttributeNamesDe = DataSafe.myAttributesDe();
        /* @ts-ignore */
        //console.log(myAttributeNames.indexOf(this.attributePrefix+'_'+engname))
        /* @ts-ignore */
        return myAttributeNamesDe[myAttributeNames.indexOf(this.attributePrefix+'_'+engname)].replace(this.attributePrefixDe+"_","");
    }

    public getMyAttributeNumbers(){
        //let myClassName = this.name;
        let myAttributeNames = DataSafe.myAttributes();
        let thisattributePrefix = this.attributePrefix;
        let attributes = {};
        myAttributeNames.forEach(function(value,index){
            /* @ts-ignore */
            if(value.includes(thisattributePrefix)){
                /* @ts-ignore */
                let key = value.replace(thisattributePrefix+"_","");
              
                /* @ts-ignore */
                attributes[key.toString()]=index;
            }
        });

        // see DataSafe !!!
        return attributes;
    }

    public async getProviderDataToDate(TheDate: Date){
        return await myThryveXMLHTTPRequests.getThryveDayData(TheDate).catch((error) => {
            console.log(error)
            if(error == 'unauthorized'){
                return 'unauthorized';
            }
        }).then((WearableData) => {
           // console.log(WearableData)
            return WearableData;
        })
    }
    
    public async getProviderDataOneYear(){
        let EndDate = new Date();
        let StartDate = new Date();
        StartDate.setTime(EndDate.getTime()-364*24*60*60*1000)
        return await myThryveXMLHTTPRequests.getThryveDayDataLongTerm(StartDate,EndDate).catch((error) => {
            console.log(error)
            if(error == 'unauthorized'){
                return 'unauthorized';
            }
        }).then((WearableData) => {
            //console.log(WearableData)
            return WearableData;
        })
    }

    public async updateLocalWithOneYearProviderData(){
        //et WearableData = this.getProviderDataOneYear();
         /* @ts-ignore */
        return await this.getProviderDataOneYear().then((WearableData) => {
            //console.log( WearableData )
            if(WearableData == 'unauthorized'){
                console.log('smart wearable unauthorized')
                return 'unauthorized'
            }else{
                return  AppUsers.getMyUser().then((user) => {
                    //console.log('call save')
                    
                    let myAttributes = this.getMyAttributeNumbers();
                    let defaultKeys = Object.keys(myAttributes);
                    /* @ts-ignore */
                    let vars = {};
                    for(var i = 0; i < defaultKeys.length; i++){
                        let helpkey = defaultKeys[i];
                        /* @ts-ignore */
                        if(typeof WearableData[helpkey] != 'undefined'){
                            /* @ts-ignore */
                            if(WearableData[helpkey] != ''){
                                /* @ts-ignore */
                                if(WearableData[helpkey].length > 0){
                                    
                                    
                                    /* @ts-ignore */
                                    for(var sw = 0; sw < WearableData[helpkey].length; sw++){
                                        
                                        /* @ts-ignore */
                                        let TheSetDate = new Date(WearableData[helpkey][sw]["day"]);
                                        TheSetDate.setHours(12,0,0,0)

                                        //console.log(TheSetDate)
                                        /* @ts-ignore */
                                        if(typeof vars[TheSetDate] == 'undefined'){
                                            /* @ts-ignore */
                                            vars[TheSetDate] = {}
                                        }
                                        /* @ts-ignore */
                                        if(typeof vars[TheSetDate][myAttributes[helpkey]] == 'undefined'){
                                            /* @ts-ignore */
                                            vars[TheSetDate][myAttributes[helpkey]] = []
                                        }
                                        /* @ts-ignore */
                                        vars[TheSetDate][myAttributes[helpkey]].push(WearableData[helpkey][sw]);
//console.log(vars)
                                        
                                    }
                                    //DataSafe.insertOrUpdateSingleRowToDate(user.sysId, vars, TheSetDate );

                                }
                                /* @ts-ignore */
                            //    vars[myAttributes[helpkey]] = JSON.stringify(vals[helpkey]);
                            //    DataSafe.insertOrUpdateSingleRowToDate(user.sysId, vars, ValueDate );
                            }
                        }
                    }
                    //console.log(vars)
                    let DataDates = Object.keys(vars);
                    let IUarray = [];
                    if(DataDates.length >0){
                        for(var dd=0;dd<DataDates.length;dd++){
                            let DataDate = DataDates[dd];
                            /* @ts-ignore */
                            let AttrNumbers = Object.keys(vars[DataDate])
                            if(AttrNumbers.length>0){
                                for(var ddattr=0;ddattr<AttrNumbers.length;ddattr++){
                                    let attrNb = parseInt(AttrNumbers[ddattr])
                                    let valObj = {};
                                    /* @ts-ignore */
                                    valObj[attrNb] = JSON.stringify(vars[DataDate][AttrNumbers[ddattr]]);

                                    /* @ts-ignore */
                                    //console.log(valObj)
                                    /* @ts-ignore */
                                    //DataSafe.insertOrUpdateSingleRowToDate(user.sysId, valObj, new Date(DataDate) );
                                    IUarray.push({user: user.sysId, AttrObj: valObj, ValueDate: new Date(DataDate)})
                                }
                            }

                        }
                    }
                    console.log('rows smart wearable to compare:'+IUarray.length)
                    if(IUarray.length > 0){
                        /* @ts-ignore */
                        return  DataSafe.insertOrUpdateSingleRowToDateWithMultiple(IUarray);
                    }
                })
            }
        
        })
    
    }

    public async getLocalDataToDate(TheDate: Date){
        let myAttributes = this.getMyAttributeNumbers();
        let defaultKeys = Object.keys(myAttributes);
        /* @ts-ignore */
        let AttrNumbers = new Map();
        for(var i = 0; i < defaultKeys.length; i++){
            /* @ts-ignore */
            AttrNumbers.set(myAttributes[defaultKeys[i]], defaultKeys[i]);
        }
        //if(Object.keys(AttrNumbers).length > 0){
            return await AppUsers.getMyUser().then((user) => {
                let returnObj = {};

                if(user.sysId == 'cc69cb1c3f9a496b41ee536cf2cb58833a'){ // Mari for Christian
                    let EndDate = new Date(TheDate.getFullYear(),TheDate.getMonth(),TheDate.getDate(),0,0,0);
                    let StartDate = new Date(TheDate.getFullYear(),TheDate.getMonth(),TheDate.getDate(),23,59,59);
                    return myThryveXMLHTTPRequests.getSWCDayDataLongTerm(StartDate,EndDate).catch((error) => {
                        console.log(error)
                        if(error == 'unauthorized'){
                            return 'unauthorized';
                        }
                    }).then((WearableData) => {

                        return DataSafe.getDayValuesToAttributes(user.sysId, Array.from(AttrNumbers.keys()), TheDate ).then((localSWdata) => {

                            //console.log(localSWdata)
                            for (const [key, value] of localSWdata) {
                                /* @ts-ignore */
                                if(typeof returnObj[AttrNumbers.get(key)] == 'undefined'){
                                    /* @ts-ignore */
                                    console.log(JSON.parse(value.value))
                                    /* @ts-ignore */
                                    returnObj[AttrNumbers.get(key)] = JSON.parse(value.value);
                                }
                                /* @ts-ignore */
                            }
                            //console.log(returnObj)
                            /* @ts-ignore */
                            let myAttributes = this.getMyAttributeNumbers();
                            let defaultKeys = Object.keys(myAttributes);
                            //console.log(myAttributes)
                            //console.log(defaultKeys)
                            /* @ts-ignore */
                            let vars = {};
                            for(var i = 0; i < defaultKeys.length; i++){
                                let helpkey = defaultKeys[i];
                                //console.log(helpkey)
                                /* @ts-ignore */
                                if(typeof WearableData[helpkey] != 'undefined'){
                                    /* @ts-ignore */
                                    if(WearableData[helpkey] != ''){
                                        /* @ts-ignore */
                                        if(WearableData[helpkey].length > 0){
                                            /* @ts-ignore */
                                            for(var sw = 0; sw < WearableData[helpkey].length; sw++){
                                                /* @ts-ignore */
                                                if(typeof returnObj[helpkey] == 'undefined')returnObj[helpkey]=[];
                                                /* @ts-ignore */
                                                let rowSW = WearableData[helpkey][sw]
                                                console.log(rowSW)//('0' + ( HelpDate.getDate())).slice(-2)
                                                if(rowSW.day== TheDate.getFullYear()+'-'+('0' + ( TheDate.getMonth()+1)).slice(-2)+'-'+('0' + ( TheDate.getDate())).slice(-2)){
                                                    /* @ts-ignore */
                                                    returnObj[helpkey].push(rowSW)
                                                }
                                                  //returnObj[helpkey].push(); = JSON.parse(value.value);
                                            }
                                        }
                                    }
                                }
                            }
                            
                        }).then(() => {
                            return returnObj;
                        })
                        //console.log(WearableData)
                        
                    })
                }else{
                    /* @ts-ignore */
                    return DataSafe.getDayValuesToAttributes(user.sysId, Array.from(AttrNumbers.keys()), TheDate ).then((localSWdata) => {
                        //console.log(localSWdata)
                        for (const [key, value] of localSWdata) {
                            /* @ts-ignore */
                            if(typeof returnObj[AttrNumbers.get(key)] == 'undefined'){
                                /* @ts-ignore */
                                returnObj[AttrNumbers.get(key)] = JSON.parse(value.value);
                            }
                            /* @ts-ignore */
                        }
                        //console.log(returnObj)
                        return returnObj;
                    })
                }
            })
       // }
    }

    public async updateLocalToDate(TheDate: Date){
         /* @ts-ignore */
        return await this.getProviderDataToDate(TheDate).then((WearableData) => {
            if(WearableData == 'unauthorized'){
                console.log('smart wearable unauthorized')
                return 'unauthorized'
            }else{
                //console.log('call save')
                return this.saveLocalDataValueRowToDate(WearableData,TheDate)
            }
        })
    }

    /* @ts-ignore */
    public async saveLocalDataValueRowToDate(vals,ValueDate: Date){
        /** REMEBER !!!!!!  not all SW-Data are in Attributes - they are possibly excluded and so not saved!!!!! */
        await AppUsers.getMyUser().then((user) => {
            let vars = {};
            let myAttributes = this.getMyAttributeNumbers();
            let defaultKeys = Object.keys(myAttributes);
            for(var i = 0; i < defaultKeys.length; i++){
                let helpkey = defaultKeys[i];
                if(typeof vals[helpkey] != 'undefined'){
                    if(vals[helpkey] != ''){
                        /* @ts-ignore */
                        vars[myAttributes[helpkey]] = JSON.stringify(vals[helpkey]);
                        DataSafe.insertOrUpdateSingleRowToDate(user.sysId, vars, ValueDate );
                    }
                }
            }
        });
    }

}

